.editQuizFooter {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	width: 100%;

	&:has(> :only-child) {
		justify-content: flex-end;
	}
}

.editQuizFooterRightWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.625rem;
	align-items: center;
	justify-content: center;
}

.editQuizFooter :global(.MuiButton-root) {
	min-width: 120px;
	width: auto;
	height: 36px;
}

.modalContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
}

.editQuizSkeletonWrapper {
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 100%;
	gap: 1rem;
}

@media (max-width: 768px) {
	.editQuizFooter :global(.MuiButton-root) {
		width: 100%;
	}

	.editQuizFooter {
		flex-direction: column;
		gap: 0.5rem;
	}
	.editQuizFooterRightWrapper {
		width: 100%;
	}
}
